const carouselItems = [
  {
    title: '娱乐圈偷税漏税完整名单',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20financial%20documents%20and%20spreadsheets%20with%20red%20markings%20under%20dramatic%20overhead%20light%2C%20dark%20wooden%20desk%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%2C%20warm%20tungsten%20glow%2C%20shadows%20on%20paper&width=600&height=800&seq=carousel-feature-01&orientation=portrait',
  },
  {
    title: '2026上半年翻车网红盘点',
    image: 'https://readdy.ai/api/search-image?query=Cracked%20smartphone%20screen%20showing%20social%20media%20feed%20with%20dramatic%20pink%20light%20reflections%2C%20shattered%20glass%20effect%2C%20dark%20surroundings%2C%20digital%20chaos%20aesthetic%2C%20cyberpunk%20vibe%2C%20distorted%20display&width=600&height=800&seq=carousel-feature-02&orientation=portrait',
  },
  {
    title: '选秀节目投票内幕全揭秘',
    image: 'https://readdy.ai/api/search-image?query=Theater%20stage%20from%20behind%20the%20curtains%2C%20audience%20lights%20blurred%20in%20the%20distance%2C%20dark%20backstage%20area%2C%20dramatic%20contrast%2C%20theatrical%20mystery%2C%20velvet%20curtains%20in%20deep%20red%20tones%2C%20eerie%20atmosphere&width=600&height=800&seq=carousel-feature-03&orientation=portrait',
  },
  {
    title: '剧组片场霸凌事件合集',
    image: 'https://readdy.ai/api/search-image?query=Abandoned%20movie%20set%20at%20night%20with%20scattered%20equipment%2C%20single%20harsh%20spotlight%20casting%20long%20shadows%2C%20empty%20director%20chair%2C%20eerie%20cinematic%20atmosphere%2C%20dark%20and%20moody%2C%20film%20noir%20style&width=600&height=800&seq=carousel-feature-04&orientation=portrait',
  },
  {
    title: '品牌代言翻车事故档案',
    image: 'https://readdy.ai/api/search-image?query=Torn%20advertising%20posters%20on%20a%20city%20wall%20at%20night%2C%20ripped%20paper%20texture%2C%20neon%20pink%20light%20casting%20on%20the%20debris%2C%20urban%20decay%20aesthetic%2C%20graffiti%20texture%2C%20dramatic%20street%20photography%20style&width=600&height=800&seq=carousel-feature-05&orientation=portrait',
  },
  {
    title: '明星人设崩塌时间线',
    image: 'https://readdy.ai/api/search-image?query=Shattered%20mirror%20with%20multiple%20cracked%20reflections%20on%20a%20dark%20table%2C%20dramatic%20lighting%2C%20broken%20glass%20pieces%20scattered%2C%20pink%20and%20red%20light%20accents%2C%20conceptual%20photography%2C%20identity%20crisis%20theme%2C%20high%20contrast&width=600&height=800&seq=carousel-feature-06&orientation=portrait',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-background-50 mb-10">
          🎯 焦点专题
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer relative"
            >
              <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden bg-background-800">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-bold text-background-50 leading-snug">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-1 text-primary-400 text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                    查看专题
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}